import { defineComponent as _defineComponent } from 'vue'
import { toRefs, ref, watch, useContext } from "@nuxtjs/composition-api";
import { useMobile } from "~/core/composables/useMobile";
import { WALLET_ERROR_CODES } from "~/core/services/utils/Constants";

interface Props {
    error: Error,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FlowError',
  props: {
    error: null
  },
  emits: ['onTryAgain', 'onCancel'],
  setup(__props: any, { emit: $emit }) {

const props = __props as { error: Error };





const { error } = toRefs(props);
const { i18n } = useContext();
const isMobile = useMobile();
const title = ref('');
const message = ref('');

const handleTryAgain = () => {
    $emit('onTryAgain');
}

const handleCancel = () => {
    $emit('onCancel');
}

watch(error, (newErr) => {
    let innerTitle = '';
    let innerMessage = '';
    let code = null;

    if (typeof newErr === 'string') {
        innerMessage = newErr;
    } else {
        innerMessage = newErr.message;
        code = newErr.code;
    }

    if (code === WALLET_ERROR_CODES.USER_REJECTED ||
        code === WALLET_ERROR_CODES.REJECTED_BY_NETWORK ||
        innerMessage.includes('rejected')) {
        innerTitle = 'Transaction Rejected';
        innerMessage = i18n.t('Your transaction has been declined. Please attempt the transaction again.');
    } else if (code === WALLET_ERROR_CODES.METAMASK_INTERNAL_ERROR ||
        innerMessage.includes('nonce mismatch') || innerMessage.includes('nonce too low')) {
        innerTitle = 'Transaction in Process';
        innerMessage = i18n.t('Please wait for the ongoing transaction on the blockchain to complete before initiating a new one.');
    } else if (innerMessage.includes('insufficient funds for gas * price + value')) {
        innerTitle = 'Transaction Rejected';
        innerMessage = i18n.t('Your transaction has been declined. Please add BNB to your wallet and attempt the transaction again.');
    } else if (innerMessage.includes('reverted by EVM') || innerMessage.includes('reverted')) {
        innerTitle = 'Transaction Reverted';
        innerMessage = i18n.t('Blockchain Notification: Apologies, an error occurred on the blockchain side. Please try again.');
    } else {
        innerTitle = 'Something went wrong';
        innerMessage = 'Apologies, an unexpected error occurred. Please retry your request. If the issue persists, please contact support.';
    }
    title.value = innerTitle;
    message.value = innerMessage;
}, { immediate: true });

return { __sfc: true,$emit, props, error, i18n, isMobile, title, message, handleTryAgain, handleCancel }
}

})